export interface IOnboardDingPlaylistResponseField {
  _id: string;
  playlistKey: string;
  name: string;
  description: string;
  videos: IVideosField[];
  thumbnailUrl: string;
  localisation: IVideoLocalisation;
}

export interface IVideoLocalisation {
  name: ISupportedLocalisation;
  _id: string;
  description?: ISupportedLocalisation;
}

export interface ISupportedLocalisation {
  ms?: string;
  ta?: string;
  "zh-Hans"?: string;
  "zh-Hant"?: string;
  _id: string;
  zh?: string;
}

export interface IVideosField {
  id: string;
  _id: string;
  name: string;
  thumbnailUrl: string;
  description: string;
  sources: IVideoSource[];
}

export interface IVideoSource {
  format: string;
  quality: VideoQuality;
  url: string;
}

export enum VideoQuality {
  ORIGINAL = "ORIGINAL",
  HD = "HD",
  FHD = "FHD",
}

export interface DurationProps {
  playlistKey: string;
  index: number;
  duration: number;
}
